// src/components/ui/Container.jsx

import React from "react";
import clsx from "clsx";

/**
 * Container component for consistent horizontal padding and max-widths
 * @param {React.ReactNode} children - Content inside the container
 * @param {string} className - Optional extra classes
 */
const Container = ({ children, className }) => {
  return (
    <div
      className={clsx(
        "mx-auto px-2 sm:px-2 lg:px-2 max-w-full",
        className
      )}
    >
      {children}
    </div>
  );
};

export default Container;